import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";
import Window from "../../components/Window";
import Icon from "../../components/Icon";
import { PostComposer } from "../../components/Postcards";
import { getUsername } from "../../penpal";
import { POST_CATEGORIES, submitPiece } from "../../post";
import "../../styles.css";

// "Drop it in the mailbox": send writing to the PenPal Post's editors.
export default function SubmitPiece() {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const [category, setCategory] = useState(POST_CATEGORIES[0]);
  const [username, setUsername] = useState("");

  useEffect(() => {
    if (user) getUsername(user.uid).then(setUsername).catch(() => setUsername("unknown"));
  }, [user]);

  if (!user) return null;

  return (
    <div className="page-narrow flex flex-col gap-5 !max-w-3xl">
      <Link to="/post" className="btn btn-plain btn-sm self-start">
        <Icon name="back" size={16} /> The PenPal Post
      </Link>
      <Window title="the_mailbox.exe" tone="pink" minimizable={false}>
        <h1 className="window-heading flex items-center gap-2">
          <Icon name="mail" size={26} tone="pink" pop /> Drop it in the mailbox
        </h1>
        <p className="window-sub">
          Poems, essays, stories, letters, little histories: if you'd like to share
          it with the network, send it in. We'll publish it, but a real person
          reads everything first, so it can take a day or two to show up.
        </p>
        {username === "unknown" ? (
          <p className="notice text-sm">
            Choose a username on <Link to="/profile">My Profile</Link> first.
          </p>
        ) : (
          <>
            <label className="field">
              <span className="field-label">What kind of writing is it?</span>
              <select className="input" value={category} onChange={(e) => setCategory(e.target.value)}>
                {POST_CATEGORIES.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </label>
            <PostComposer
              titleLabel="Title"
              titlePlaceholder="e.g. Notes from my first year on hormones"
              bodyPlaceholder="Write it here. Formatting like bold, italics, and lists is welcome."
              categoryOptions={[]}
              anonymousHint="Readers see 'anonymous' instead of your username. Editors and moderators can still see who sent it. Anonymous pieces can't receive kudos."
              submitLabel="Send it to the Post Office"
              onPost={async (p) => {
                const id = await submitPiece(user.uid, username || (await getUsername(user.uid)), {
                  category,
                  subject: p.subject,
                  message: p.message,
                  color: p.color,
                  cw: p.cw,
                  anonymous: p.anonymous,
                });
                navigate(`/post/${id}`);
              }}
            />
          </>
        )}
      </Window>
    </div>
  );
}
